import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import PagedTable from "../common/PagedTable";
import { QueryResponse } from "../../../types/QueryResponse";
import { QueryArguments } from "../../../types-business/QueryArguments";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  UncontrolledTooltip
} from "reactstrap";
import ProductClassification from "../../containers/productClassification";
import BaseInput from "../../../toolkit/baseInput";
import { userHasPermission } from "../../../utils/accessTree";
import permissionCodes from "../../../utils/permissionCodes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import DeleteProductModal from "../common/deleteProductModal";
import {
  verificarEliminacionProducto,
  eliminarProductoFisicamente
} from "../../actions/products";
import {
  infoNotification,
  errorNotification,
  successNotification
} from "../../../utils/notifications";

interface Props {
  products: QueryResponse<Product>;
  searching: boolean;
  onClickNewProduct: (product) => any;
  reloadProducts: boolean;
  fetchData: () => void;
  history: any;
  match: any;
  filters: Filters;
  onChangeFilter: any;
  getProducts: (args?: QueryArguments) => any;
  sportsProducts: [{ id: string; nombre: string }];
}

interface Filters {
  nombre: string;
  configuracionComisiones: boolean;
  page: number;
  size: number;
}

interface Product {
  id: string;
  clasificacionId: string;
  nombre: string;
  estatus: string;
  publicarPrecio: boolean;
  fechaInicioVigencia: string;
  fechaFinVigencia: string;
  descripcion: string;
  posibleEliminacion?: boolean;
}

interface State {
  showDeleteModal: boolean;
  deleteResumen: any;
  deletingProduct: boolean;
}

class SportsProducts extends React.Component<Props, State> {
  state = {
    showDeleteModal: false,
    deleteResumen: null,
    deletingProduct: false
  };
  handleEditProduct = product => {
    this.props.onClickNewProduct(product);
  };

  search = () => {
    this.props.getProducts(this.props.filters);
  };

  handleDeleteProduct = async (productoId: string) => {
    try {
      infoNotification("Verificando si el producto puede ser eliminado...");
      const response = await verificarEliminacionProducto(parseInt(productoId));
      this.setState({
        showDeleteModal: true,
        deleteResumen: response.data
      });
    } catch (error) {
      errorNotification("Error al verificar la eliminación del producto");
    }
  };

  handleConfirmDelete = async () => {
    if (!this.state.deleteResumen) return;

    try {
      this.setState({ deletingProduct: true });
      infoNotification("Eliminando producto...");
      await eliminarProductoFisicamente(this.state.deleteResumen.productoId);
      successNotification("Producto eliminado exitosamente");
      this.setState({
        showDeleteModal: false,
        deleteResumen: null,
        deletingProduct: false
      });
      this.search();
    } catch (error) {
      this.setState({ deletingProduct: false });
      errorNotification("Error al eliminar el producto");
    }
  };

  handleCancelDelete = () => {
    this.setState({
      showDeleteModal: false,
      deleteResumen: null,
      deletingProduct: false
    });
  };

  onChangeFactory = (event, fieldName) => {
    const value = event.target.value;
    this.props.onChangeFilter(value, fieldName);
  };

  onChangeBooleanFactory = (event, fieldName) => {
    const value = event.target.value;
    const booleanValue = value ? value === "1" : null;
    this.props.onChangeFilter(booleanValue, fieldName);
  };

  render() {
    const columns = [
      { name: "ID", id: "id", minWidth: 30, className: "text-center" },
      { name: "Nombre", id: "nombre", minWidth: 160, className: "text-center" },
      {
        name: "Estatus",
        id: "estatus",
        minWidth: 40,
        className: "text-center"
      },
      {
        name: "Conf. de comisión",
        id: "configuracionComision",
        minWidth: 60,
        className: "text-center"
      },
      {
        name: "Inicio de vigencia",
        id: "fechaInicioVigencia",
        minWidth: 60,
        className: "text-center"
      },
      {
        name: "Fin de vigencia",
        id: "fechaFinVigencia",
        minWidth: 60,
        className: "text-center"
      },
      {
        headerActions: userHasPermission(
          permissionCodes.PRODUCTS_CREATE_PRODUCT
        )
          ? [{ name: "add", f: this.props.onClickNewProduct }]
          : []
      }
    ];

    let actions = [];
    if (userHasPermission(permissionCodes.PRODUCTS_EDIT_PRODUCT)) {
      actions = actions.concat([{ name: "edit", f: this.handleEditProduct }]);
    } else if (userHasPermission(permissionCodes.PRODUCTS_VIEW_PRODUCTS)) {
      actions = actions.concat([{ name: "view", f: this.handleEditProduct }]);
    }

    // Agregar acción de eliminación si tiene permiso
    if (userHasPermission(permissionCodes.PRODUCTOS_ELIMINAR_FISICAMENTE)) {
      actions = actions.concat([
        {
          name: "custom",
          f: product => {
            const canDelete = product.posibleEliminacion;
            return (
              <span
                onClick={() => this.handleDeleteProduct(product.id)}
                style={{ cursor: "pointer", fontSize: "16px" }}
                id={`delete-product-${product.id}`}
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  color={canDelete ? "#600" : "#777"}
                />
                <UncontrolledTooltip
                  placement="bottom"
                  target={`delete-product-${product.id}`}
                >
                  {canDelete
                    ? "Eliminar producto"
                    : "Ver resumen de eliminación"}
                </UncontrolledTooltip>
              </span>
            );
          }
        }
      ]);
    }

    return (
      <Container className="p-0 mt-3">
        <Form
          onSubmit={e => {
            e.preventDefault();
            this.search();
          }}
        >
          <Row>
            <Col style={{ paddingBottom: "5px" }} xs={12} md={7} lg={7}>
              <BaseInput
                label={"Nombre del producto"}
                name="productName"
                id="productname"
                placeholder="Nombre del Producto"
                dataQAId={"product_name"}
                onChange={productName =>
                  this.onChangeFactory(productName, "nombre")
                }
              />
            </Col>
            <Col style={{ paddingBottom: "5px" }} xs={12} md={3} lg={3}>
              <BaseInput
                label={"Config. de comisiones"}
                name="config"
                type="select"
                options={[
                  { value: "", label: "Seleccione" },
                  { value: "1", label: "Autorizada" },
                  { value: "0", label: "No autorizada" }
                ]}
                id="productname"
                placeholder="Nombre del Producto"
                onChange={config =>
                  this.onChangeFactory(config, "configuracionComisiones")
                }
              />
            </Col>
            <Col xs={12} md={2} lg={2} className="mt-4">
              <Button
                size="sm"
                className={`float-right btn-block`}
                type="submit"
              >
                Buscar
              </Button>
            </Col>
          </Row>
        </Form>
        <PagedTable
          data={this.props.products}
          columns={columns}
          actions={actions}
          fetchData={this.props.fetchData}
          searching={this.props.searching}
        />
        <DeleteProductModal
          isOpen={this.state.showDeleteModal}
          resumen={this.state.deleteResumen}
          loading={this.state.deletingProduct}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </Container>
    );
  }
}
export default withRouter(withStyles(s)(SportsProducts));
